export default __webpack_public_path__ + "static/media/arrow-down.449f59ee.svg";